import { Modal } from 'react-bootstrap';
import { StyledEditContactModal } from './EditContactModal.styled';
import Select from 'react-select';
import { selectCustomStyles } from '../../common/shared/select.styled';
import { selectContactTypesOptions } from './common';
import Input from '../../common/simple/input';
import { useEffect, useState } from 'react';
import { NotificationManager } from 'react-notifications';
import { useAccessToken } from '../../common/hooks/useAccessToken';

const EditContactModal = ({ show, onHide, type, value, id, reloadContacts }) => {
    const [contactTypeOption, setContactTypeOption] = useState(selectContactTypesOptions[0]);
    const [contactValue, setContactValue] = useState('');
    const client = useAccessToken();

    useEffect(() => {
        setContactTypeOption(selectContactTypesOptions.find(option => option.value === type));
        setContactValue(value);
    }, [show]);

    const onSave = async () => {
        try {
            await client.managers.contacts.updateContact({
                id,
                type: contactTypeOption.value,
                value: contactValue,
            });
            NotificationManager.success('Contact updated successfully');
            reloadContacts();
            onHide();
        } catch (e) {
            NotificationManager.error(e.message);
        }
    }

    const onDelete = async () => {
        try {
            await client.managers.contacts.deleteContact({id});
            NotificationManager.success('Contact deleted successfully');
            reloadContacts();
            onHide();
        } catch (e) {
            NotificationManager.error(e.message);
        }
    }

    return (
        <StyledEditContactModal
            centered
            show={show}
            onHide={onHide}
        >
             <span
                 className="modal-close"
                 onClick={onHide}
             >
                &#215;
            </span>
            <Modal.Header>
                <Modal.Title>Edit/delete contact</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="container inputs">
                    <div className="row">
                        <div className="col-md-6 input-container">
                            <label htmlFor="contactType">Contact type</label>
                            <Select
                                styles={selectCustomStyles}
                                options={selectContactTypesOptions}
                                placeholder="Select contact type"
                                name="contactType"
                                value={contactTypeOption}
                                onChange={setContactTypeOption}
                            />
                        </div>
                        <div className="col-md-6 input-container">
                            <Input
                                label="Contact value"
                                name="contactValue"
                                value={contactValue}
                                onChange={e => setContactValue(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="buttons">
                    <button
                        className="bllink-button"
                        onClick={() => onDelete()}
                    >Delete</button>
                    <button
                        className="bllink-button"
                        onClick={() => onSave()}
                    >Save</button>
                </div>
            </Modal.Body>
        </StyledEditContactModal>
    )
}

export default EditContactModal;